import { render, staticRenderFns } from "./WxUser.vue?vue&type=template&id=2963a67b&scoped=true"
import script from "./WxUser.vue?vue&type=script&lang=js"
export * from "./WxUser.vue?vue&type=script&lang=js"
import style0 from "./WxUser.vue?vue&type=style&index=0&id=2963a67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963a67b",
  null
  
)

export default component.exports